export const usernameValidator = (value: string) => { 
    const error: any = {};
    if (!/^[a-zA-Z0-9_-]*$/.test(value) || value.length === 0){
        error.invalid = true;
    }
    return Object.keys(error).length !== 0 ? error : null;
}